import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import axiosAPI from "../config/axiosInstance";
import { miniSpinner } from "../assets/icons";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import logo from "../assets/logo.svg"; // Assuming you have a logo image
const SignUp = () => {
  const [loading, setLoading] = useState(false); // Add this line
  const [openARM, setopenARM] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    companyName: "",
    email: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);

  // after Registering, open the model

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    toast.dismiss(); // Dismiss any previous toast notifications

    // Validation checks
    const { firstName, lastName, phoneNumber, companyName, email, password } =
      formData;
    if (
      !firstName ||
      !lastName ||
      !phoneNumber ||
      !companyName ||
      !email ||
      !password
    ) {
      toast.error("All fields are required."); // change it to react-toastify or react-hot-toast`
      return;
    }
    try {
      setLoading(true); // Start loading
      const response = await axiosAPI("post", "register-company", formData);
      setopenARM(response.success);
    } catch (error) {
      toast.error(
        error.response?.data?.error || "An error occurred during registration.",
      );
    } finally {
      setLoading(false); // Stop loading regardless
      setopenARM(true);
    }
  };

  return (
    <div className="flex h-screen w-screen relative">
      <div className="hidden md:flex md:w-1/2 bg-lightBlue text-white flex-col items-center justify-center p-10">
        <Link className="absolute top-0 left-0" to="/">
          <img
            src={logo}
            alt="Logo"
            className="h-[60px] select-none"
            draggable="false"
          />
        </Link>
        <h2 className="text-3xl font-bold text-center">
          Data Ingestion Made Easy
        </h2>
        <p className="mt-4 text-center">
          Tame Daily Sales Chaos — from POS and E-Commerce to Bookkeeping-Ready
          Sheets.
          <br /> No Code or Manual Cleanup.
        </p>
      </div>

      <div className="w-full md:w-1/2 flex flex-col justify-center ">
        <div className="px-4 sm:px-10 md:px-16 lg:px-20 xl:px-24 ">
          <h2 className="text-2xl font-bold">Register your organization</h2>
          <p className="mt-2 text-sm">
            Already using Ledgerate?{" "}
            <a href="/portal/login" className="text-blue-600">
              Login
            </a>
          </p>

          <form className="mt-6 space-y-4" onSubmit={handleFormSubmit}>
            <div className="">
              <label className="block text-sm font-medium">
                FIRST NAME <span className="text-red-600">*</span>
              </label>
              <input
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleInputChange}
                className="w-full border p-2 rounded mt-1"
                placeholder="Enter your first name"
              />
            </div>
            <div className="">
              <label className="block text-sm font-medium">
                LAST NAME <span className="text-red-600">*</span>
              </label>
              <input
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleInputChange}
                className="w-full border p-2 rounded mt-1"
                placeholder="Enter your last name"
              />
            </div>
            <div className="">
              <label className="block text-sm font-medium">
                PHONE NUMBER <span className="text-red-600">*</span>
              </label>
              <input
                type="text"
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleInputChange}
                className="w-full border p-2 rounded mt-1"
                placeholder="Enter your phone number"
              />
            </div>

            <div>
              <label className="block text-sm font-medium">
                ORGANIZATION NAME <span className="text-red-600">*</span>
              </label>
              <input
                type="text"
                name="companyName"
                value={formData.companyName}
                onChange={handleInputChange}
                className="w-full border p-2 rounded mt-1"
                placeholder="Enter your organization's name"
              />
            </div>

            <div>
              <label className="block text-sm font-medium">
                LOGIN EMAIL <span className="text-red-600">*</span>
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                className="w-full border p-2 rounded mt-1"
                placeholder="Enter your email"
              />
            </div>

            <div>
              <label className="block text-sm font-medium">
                PASSWORD <span className="text-red-600">*</span>
              </label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleInputChange}
                  className="w-full border p-2 rounded mt-1"
                  placeholder="Enter your password"
                />
                <div className="absolute inset-y-0 right-0 flex items-center pr-3">
                  <button
                    type="button"
                    className="text-gray-500 hover:text-gray-700 focus:outline-none"
                    onClick={() => setShowPassword((prev) => !prev)}
                  >
                    {showPassword ? <Eye size={18} /> : <EyeOff size={18} />}
                  </button>
                </div>
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className={`w-full bg-lightBlue text-white p-2 rounded mt-4 flex items-center justify-center gap-2 transition-all duration-150 ease-in-out transform 
    hover:bg-blue-900 
    active:scale-95 
    disabled:opacity-60 disabled:cursor-not-allowed`}
            >
              {loading && miniSpinner}
              {loading ? "Please wait..." : "Register"}
            </button>
          </form>
        </div>
      </div>

      {openARM && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl p-8 max-w-[800px] w-full text-center animate-fade-in transition-all">
            <div className="flex justify-center mb-4">
              <div className="bg-green-100 text-green-600 rounded-full p-3 shadow-md">
                <svg
                  className="w-8 h-8"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>
            </div>

            <h2 className="text-2xl font-bold text-gray-800 mb-2">
              Thank you for registering!
            </h2>
            <p className="text-gray-600 text-sm mb-6 leading-relaxed">
              Your company has been successfully registered with{" "}
              <span className="font-semibold text-gray-800">Ledgerate</span>.
              <br />
              We're excited to have you on board. You can now log in to your
              dashboard and begin your journey with us.
            </p>

            <button
              onClick={() => {
                setopenARM(false);
                window.location.href = "/login";
              }}
              className="bg-blue-600 hover:bg-blue-700 transition-all duration-150 text-white px-4 py-1.5 rounded-lg shadow-sm font-medium active:scale-95"
            >
              Get Started
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SignUp;
